import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const FeeSummary = ({
  rateDetails
}) => {

  if (Object.keys(rateDetails).length === 0) return(<></>);

  return (
    <>
    <div className="fee-summary">
      {rateDetails?.totalGreenFee != 0.00 && (
          <>
          <div className="row margin-br5">
            <div className="col-sm-10 col-xs-8 text-right">
              <h6 className="margin-0">Green Fee:</h6>
            </div>
            <div className="col-sm-2 col-xs-4 text-right">
              <h6 className="margin-0">₹ {rateDetails?.totalGreenFee}</h6>
            </div>
          </div>
          </>
      )}

      {/* Cart Fee Row */}
      {rateDetails?.totalCartFee && (
        <div className="row margin-br5">
          <div className="col-sm-10 col-xs-8 text-right">
            <h6 className="margin-0">{rateDetails?.cartCount} Cart:</h6>
          </div>
          <div className="col-sm-2 col-xs-4 text-right">
            <h6 className="margin-0">₹ {rateDetails?.totalCartFee}</h6>
          </div>
        </div>
      )}

      {/* Caddy Fee Row */}
      {rateDetails?.totalCaddyFee && (
        <div className="row margin-br5">
          <div className="col-sm-10 col-xs-8 text-right">
            <h6 className="margin-0">{rateDetails?.caddyCount} Caddy:</h6>
          </div>
          <div className="col-sm-2 col-xs-4 text-right">
            <h6 className="margin-0">₹ {rateDetails?.totalCaddyFee}</h6>
          </div>
        </div>
        )}
        
         {/* Discount Row */}
      {rateDetails?.discountAmount ? (
        <div className="row margin-br5">
          <div className="col-sm-10 col-xs-8 text-right">
            <h6 className="margin-0">Discount:</h6>
          </div>
          <div className="col-sm-2 col-xs-4 text-right">
            <h6 className="margin-0">- ₹ {rateDetails?.discountAmount}</h6>
          </div>
        </div>
      ):null}

      {/* SGST Row */}
      <div className="row margin-br5">
        <div className="col-sm-10 col-xs-8 text-right">
          <h6 className="margin-0">SGST 9%:</h6>
        </div>
        <div className="col-sm-2 col-xs-4 text-right">
          <h6 className="margin-0">₹ {(parseFloat(rateDetails?.tax)/2).toFixed(2)}</h6>
        </div>
      </div>

      {/* CGST Row */}
      <div className="row margin-br5">
        <div className="col-sm-10 col-xs-8 text-right">
          <h6 className="margin-0">CGST 9%:</h6>
        </div>
        <div className="col-sm-2 col-xs-4 text-right">
          <h6 className="margin-0">₹ {(parseFloat(rateDetails?.tax)/2).toFixed(2)}</h6>
        </div>
      </div>

      {/* Total Amount Row */}
      <div className="row margin-br5">
        <div className="col-sm-10 col-xs-8 text-right">
          <h6 className="margin-0">
            <strong>Total:</strong>
          </h6>
        </div>
        <div className="col-sm-2 col-xs-4 text-right">
          <h6 className="margin-0">
            <strong>₹ {rateDetails?.finalAmount}</strong>
          </h6>
        </div>
      </div>

      {/* View Rate Card Link */}
      <div className="row margin-r5">
        <div className="col-sm-12 text-right">
          <span>
            <Link
              className="lbl text-center margin-0"
              to='/rate-card'
              target="_blank"
              rel="noopener noreferrer"
            >
              View Green Fee Rate Chart &#x2192;
            </Link>
          </span>
        </div>
      </div>

      <hr className="divider" />
    </div>
    </>
  );
};

export default FeeSummary;
